import Vue from 'vue';
import Vuex from 'vuex';
// import * as tf from '@tensorflow/tfjs';
// import * as knnClassifier from '@tensorflow-models/knn-classifier/dist/knn-classifier';
import * as mobilenetModule from '@tensorflow-models/mobilenet';
import * as knnClassifier from '@tensorflow-models/knn-classifier/dist/knn-classifier';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import streamPlayer from '../assets/streamPlayer/streamPlayer';

Vue.use(Vuex);
const baseURL = 'https://www.fliprobot.com.tw';

const localStoragePlugin = (store) => {
  store.subscribe((mutation, payload) => {
    // console.log(payload);
    if (mutation.type === 'setCacheEmail') {
      window.localStorage.setItem('userEmail', payload.cacheEmail);
    } else if (mutation.type === 'setUserData') {
      window.localStorage.setItem('user', payload.userData);
    } else if (mutation.type === 'loginToken') {
      window.localStorage.setItem('token', payload.token);
    } else if (mutation.type === 'expireUpdate') {
      window.localStorage.setItem('tokenExperies', `${payload.tokenExperies}`);
    } else if (mutation.type === 'logout') {
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('tokenExperies');
    }
  });
};

export default new Vuex.Store({
  state: {
    connectedDevices: {},
    deviceNickName: {},
    preConnectionNumber: 0,
    mobilenet: null,
    exportKnnClassifiers: {},
    exportKnnDataSet: {},
    cacheKnn: null,
    cacheDFDActions: {},
    cacheDFD: null,
    classifiersForSave: {},
    userEmail: '',
    userData: {},
    token: '',
    tokenExperies: '',
    videoSize: 400,
    cameraRef: null,
    wifiCameraRef: null,
    wifiCamConnected: false,
    isCameraOn: false,
    isWifiCameraOn: false,
    selectedCamera: {},
    cameraSource: [],
    wifiPlayer: null,

  },
  mutations: {
    addNewDevice: (state, payload) => {
      Vue.set(state.connectedDevices, payload.name, payload.device);
    },
    removeDevice: (state, payload) => {
      Vue.delete(state.connectedDevices, payload);
    },
    changeDeviceNickName(state, payload) {
      Vue.set(state.deviceNickName, payload.name, payload.nickName);
    },
    preConnectionNumberAdd(state, count) {
      if (state.preConnectionNumber === 4) return;
      state.preConnectionNumber += count;
    },
    preConnectionNumberMinus(state, count) {
      if (state.preConnectionNumber === 0) return;
      state.preConnectionNumber -= count;
    },
    loadMobilenet(state, mobilenet) {
      state.mobilenet = mobilenet;
    },
    addNewClassifier(state, payload) {
      const newClassifier = knnClassifier.create();
      newClassifier.setClassifierDataset(payload.tensorsData);
      state.exportKnnClassifiers[payload.name] = newClassifier;
      state.exportKnnDataSet[payload.name] = payload.dataset;
      state.classifiersForSave[payload.name] = payload;
    },
    removeClassifier(state, payload) {
      Vue.delete(state.exportKnnClassifiers, payload);
    },
    cacheKnnClassifier(state, payload) {
      state.cacheKnn = payload;
    },
    cacheDFDActionsData(state, payload) {
      state.cacheDFDActions = payload;
    },
    cacheDFDData(state, payload) {
      state.cacheDFD = payload;
    },
    setCacheEmail(state, payload) {
      state.cacheEmail = payload;
    },
    setUserData(state, payload) {
      state.userData = payload;
    },
    loginToken(state, payload) {
      state.token = payload;
    },
    expireUpdate(state, payload) {
      state.tokenExperies = payload;
    },
    logout(state) {
      state.token = '';
      state.tokenExperies = '';
    },
    videoSizeAdjust(state, payload) {
      state.videoSize = payload;
    },
    setWifiPlayer(state) {
      state.wifiPlayer = new streamPlayer.Player('http://192.168.4.1:80/stream');
    },
    setCameraRef(state, payload) {
      state.cameraRef = payload.cameraRef;
      state.wifiCameraRef = payload.wifiCameraRef;
      if (state.wifiPlayer) {
        state.wifiPlayer.setCanvas(state.wifiCameraRef);
      }
      // state.wifiPlayer = new streamPlayer.Player(state.wifiCameraRef, 'http://192.168.4.1:80/stream');
    },
    updatecameraSource(state, payload) {
      state.cameraSource = payload;
    },
    updateWifiCameraSource(state, payload) {
      state.wifiCamConnected = payload;
      if (!payload) {
        state.isWifiCameraOn = payload;
      }
    },
    changeCamerStatus(state, payload) {
      state.isCameraOn = payload.isCameraOn;
      state.isWifiCameraOn = payload.isWifiCameraOn;
    },
    selectCamera(state, payload) {
      state.selectedCamera = payload;
    },
  },
  actions: {
    loadMobilenet: async ({ commit }, payload) => {
      console.log('start load mobilenetModule', payload);
      // const mobilenet = await mobilenetModule.load();
      return new Promise((resolve, reject) => {
        mobilenetModule
          .load({
            version: 1,
            alpha: 1,
            // modeUrl: 'https://peter.fliprobot.com/mobilenet/imagenet/model.json',
            modelUrl: 'https://aiot.fliprobot.com/mobilenet/imagenet/model.json',
            // modelUrl: 'http://127.0.0.1:8125/mobilenet/imagenet/model.json',
          })
          .then((result) => {
            commit('loadMobilenet', result);
            resolve('Loaded Model');
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    loginProcess: async ({ commit }, payload) => {
      console.log('Start loging process', payload);
      const url = `${baseURL}/api/aiot${payload.type === 'oauth' ? '/oauth' : ''}/login`;

      return new Promise((resolve, reject) => {
        axios
          .post(url, payload.info)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              if (Object.hasOwnProperty.call(response.data, 'accessToken')) {
                commit('loginToken', response.data.accessToken);
                const userData = jwtDecode(response.data.accessToken);
                console.log(userData);
                commit('setUserData', userData);
                const expire = Math.floor(Date.now() / 1000) + response.data.expiresIn;
                commit('expireUpdate', expire);
                // commit()
                resolve(response.data);
              } else {
                reject(response.data);
              }
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    refreshToken: async ({ commit }, payload) => {
      const url = `${baseURL}/api/aiot/refresh/token`;

      const config = {
        headers: {
          Authorization: `Bearer ${payload.token}`,
        },
      };
      return new Promise((resolve, reject) => {
        axios.get(url, config)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              if (Object.hasOwnProperty.call(response.data, 'accessToken')) {
                commit('loginToken', response.data.accessToken);
                const userData = jwtDecode(response.data.accessToken);
                console.log(userData);
                commit('setUserData', userData);
                const expire = Math.floor(Date.now() / 1000) + response.data.expiresIn;
                commit('expireUpdate', expire);
                // commit()
                resolve(response.data);
              } else {
                reject(response.data);
              }
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    fakeLogin: async ({ commit }, payload) => {
      console.log('fake login', payload);
      const fakeToekn = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';
      return new Promise((resolve, reject) => {
        if (payload.info.email === 'test@123.com') {
          commit('loginToken', fakeToekn);
          const expire = Math.floor(Date.now() / 1000) + 30 * 60;
          commit('expireUpdate', expire);
          setTimeout(() => {
            resolve({ accessToken: fakeToekn, expiresIn: 30 * 60 });
          }, 1000);
        } else if (payload.info.email === 'auth_no_serial@actura.com.tw') {
          setTimeout(() => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              name: 'ForbiddenError',
              status: 403,
              statusText: 'Forbidden',
              message: 'Error.forbidden',
            });
          }, 1000);
        } else {
          setTimeout(() => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              name: 'UnauthorizedError',
              status: 401,
              statusText: 'Unauthorized',
              message: 'Error.email',
            });
          }, 1000);
        }
      });
    },
  },
  getters: {
    // eslint-disable-next-line max-len
    checkIsNewDevice: (state) => (name) => !Object.prototype.hasOwnProperty.call(state.connectedDevices, name),
    getDevice: (state) => (name) => state.connectedDevice[name],
    connectionNumber: (state) => Object.keys(state.connectedDevices).length,
    connectedDevicesWithNickname: (state) => {
      const tmpArray = [];

      Object.keys(state.connectedDevices).forEach((key) => {
        const obj = { name: key, mac: key };
        if (Object.prototype.hasOwnProperty.call(state.deviceNickName, key)) {
          obj.nickName = state.deviceNickName[key];
        } else {
          obj.nickName = state.connectedDevices[key].name.slice(-4);
        }
        tmpArray.push(obj);
      });
      return tmpArray;
    },

    cameraSourceWithWifi: (state) => {
      if (state.wifiCamConnected) {
        return [{ label: 'FR WifiCam', divice: { label: 'FR WifiCam' } }, ...state.cameraSource];
      }
      return state.cameraSource;
    },
  },
  modules: {},
  plugins: [localStoragePlugin],
});
